import { useEffect, useState } from "react";
import { FaInstagram, FaTiktok, FaSnapchatGhost } from "react-icons/fa";
import { api } from "@/lib/api";

export const CONTACT_PHONE = "07 66 77 13 00";
export const CONTACT_PHONE_HREF = "tel:+33766771300";
export const CONTACT_EMAIL = "fnk69music@gmail.com";

export const SOCIALS = [
  {
    slug: "instagram",
    name: "Instagram",
    handle: "@fnkstudio69",
    url: "https://www.instagram.com/fnkstudio69",
    Icon: FaInstagram,
    bubbleClass:
      "border-transparent text-white bg-[radial-gradient(circle_at_30%_107%,#fdf497_0%,#fdf497_5%,#fd5949_45%,#d6249f_60%,#285AEB_90%)]",
  },
  {
    slug: "tiktok",
    name: "TikTok",
    handle: "@fnkstudio69",
    url: "https://www.tiktok.com/@fnkstudio69",
    Icon: FaTiktok,
    bubbleClass: "border-white/25 bg-black text-white",
  },
  {
    slug: "snapchat",
    name: "Snapchat",
    handle: "fnkstudio69",
    url: "https://www.snapchat.com/add/fnkstudio69?share_id=YuSgziF8sC0&locale=fr-FR",
    Icon: FaSnapchatGhost,
    bubbleClass: "border-transparent bg-[#FFFC00] text-black",
  },
];

let publicCache = null;

const loadPublicSettings = () =>
  api
    .get("/settings/public")
    .then((res) => {
      publicCache = res.data || {};
      return publicCache;
    })
    .catch(() => ({}));

export const useSocials = () => {
  const [socials, setSocials] = useState(SOCIALS);
  useEffect(() => {
    const apply = (s) =>
      setSocials(SOCIALS.map((soc) => ({ ...soc, url: s[`social_${soc.slug}`] || soc.url })));
    if (publicCache) apply(publicCache);
    else loadPublicSettings().then(apply);
  }, []);
  return socials;
};

export const phoneHref = (p) => `tel:${(p || "").replace(/[^\d+]/g, "").replace(/^0/, "+33")}`;

export const useContactPhone = () => {
  const [phone, setPhone] = useState(publicCache?.contact_phone || CONTACT_PHONE);
  useEffect(() => {
    if (publicCache) {
      setPhone(publicCache.contact_phone || CONTACT_PHONE);
      return;
    }
    loadPublicSettings().then((s) => setPhone(s.contact_phone || CONTACT_PHONE));
  }, []);
  return { phone, href: phoneHref(phone) };
};

export const SocialBubbles = ({ size = "sm", className = "" }) => {
  const socials = useSocials();
  const dims = size === "lg" ? "h-11 w-11" : "h-8 w-8";
  const iconDims = size === "lg" ? "h-5 w-5" : "h-4 w-4";
  return (
    <div className={`flex items-center gap-2 ${className}`} data-testid="social-bubbles">
      {socials.map(({ slug, name, url, Icon, bubbleClass }) => (
        <a
          key={slug}
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={name}
          title={name}
          className={`flex ${dims} items-center justify-center rounded-full border transition-opacity duration-150 hover:opacity-80 ${bubbleClass}`}
          data-testid={`social-bubble-${slug}`}
        >
          <Icon className={iconDims} />
        </a>
      ))}
    </div>
  );
};
